import { Injectable } from "@angular/core";
declare var facespoofing;

export interface FaceSpoofingResult {
	liveness: boolean;
	score: any;
	threshold: any;
	message: any;
	scorePercentage?: any;
}

@Injectable()
export class FaceSpoofingNative {

	constructor() { }

	detect(path: string): Promise<FaceSpoofingResult> {
		path = path.replace('file://', '');
		console.log('path spoofing', path);
		return new Promise((resolve, reject) => {
			facespoofing.detect(path, (response: any) => {
				resolve(response)
			}, error => {
				reject(error)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/native/facespoofing.native.ts